import camelCase from 'lodash/camelCase';
import ConstituentSortFields from '@/constants/constituents/ConstituentSortFields';
import SortOrder from '../SortOrder';

const SortableFields = Object.freeze({
  [camelCase(ConstituentSortFields.DISPLAY_NAME)]: {
    defaultValue: SortOrder.ASC,
    isDefault: true,
  },
  [camelCase(ConstituentSortFields.LAST_INTERACTION_DATE)]: {
    defaultValue: SortOrder.DESC,
  },
});

export default SortableFields;
